export const RadioButton = ({ isSelected, onChange }) => {
  return (
    <input
      type="radio"
      value=""
      checked={isSelected}
      onChange={onChange}
      data-testid="radio-move-stores"
    />
  );
};